module.exports = __webpack_public_path__ + "img/school-news.48c2b9cb.svg";